import React from 'react';
import defaultUserImage from "assets/img/no_profile.png";
import { Avatar } from '@material-ui/core';

export default (props) => {
    const { image, name, surname, style, classes, className, avatarProps } = props;

    if(image || !name)
        return <Avatar alt="..." {...{ style, classes, className, ...avatarProps }} src={image ? ("/api/image/get?id=" + image) : defaultUserImage} />
    else 
        return <Avatar alt="..." {...{ style, classes, className, ...avatarProps }}>{name[0] + (surname ? surname[0] : name[1])}</Avatar>
}
